import { createReducer } from '../utils/helpers';
import { ActionTypes } from '../utils/constants';

export const categoriaState = {
  data: [],
  isLoading: false,
  error: false,
  ready: false,
  extraInfo: [],
  currentCategoria: {
    data: null,
    isLoading: false,
    error: false,
  },
  selectedBrand: null,
  brands: {
    citroen: {
      color: '#eb6327',
      image: 'https://veinsamotors.com/wp-content/uploads/2019/11/citroen-logo.svg'
    },
    mitsubishi: {
      color: '#ec1c24',
      image: 'https://veinsamotors.com/wp-content/uploads/2019/11/mitsubishi.svg'
    },
    ssangyong: {
      color: '#004b8d',
      image: 'https://veinsamotors.com/wp-content/uploads/2019/11/ssangyong.svg'
    },
    peugeot: {
      color: '#1b2754',
      image: 'https://veinsamotors.com/wp-content/uploads/2019/11/peugeot-logo.svg'
    },
    geely: {
      color: '#0d69aa',
      image: 'https://veinsamotors.com/wp-content/uploads/2020/06/Logo2.svg'
    },
    mahindra: {
      color: '#e92d46',
      image: 'https://veinsamotors.com/wp-content/uploads/2019/11/mahindra-rise-logo.svg'
    },
    default: {
      color: '#ec1c24',
    }
  },
  queryString: '',
};

export default {
  categoria: createReducer(categoriaState, {
    [ActionTypes.FETCH_CATEGORIAS_REQUEST](state, action) {
      return {
        ...state,
        isLoading: true,
        selectedBrand: action.payload.marca
      };
    },
    [ActionTypes.FETCH_CATEGORIAS_SUCCESS](state, action) {
      return {
        ...state,
        isLoading: false,
        data: action.payload.categorias,
        extraInfo: action.payload.extraInfo,
        ready: true,
      };
    },
    [ActionTypes.SAVE_INITIAL_QUERYPARAMS](state, action) {
      const { queryString } = action.payload;
      return {
        ...state,
        queryString,
      }
    },
    [ActionTypes.FETCH_CATEGORIAS_FAILURE](state) {
      return {
        ...state,
        isLoading: false,
        error: true,
        ready: true,
      };
    },
    [ActionTypes.FETCH_CATEGORIA_REQUEST](state) {
      return {
        ...state,
        currentCategoria: {
          ...state.currentCategoria,
          isLoading: true,
        },
      };
    },
    [ActionTypes.FETCH_CATEGORIA_SUCCESS](state, action) {
      const { categoria } = action.payload;

      return {
        ...state,
        currentCategoria: {
          ...state.currentCategoria,
          isLoading: false,
          data: categoria,
        },
      };
    },
    [ActionTypes.FETCH_CATEGORIA_RESET](state) {
      return {
        ...state,
        currentCategoria: {
          ...state.currentCategoria,
          data: null,
          isLoading: false,
          error: false,
          isSaving: false,
        },
      };
    },
    [ActionTypes.FETCH_CATEGORIA_FAILURE](state) {
      return {
        ...state,
        currentCategoria: {
          ...state.currentCategoria,
          isLoading: false,
          error: true,
        },
      };
    },
  }),
};
